import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q5 = ({ history }) => {
  const { t } = useTranslation();
  const Q5Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question5')}
      options={Q5Options}
      nextUrl="q6"
      screenName="q5"
    />
  );
};

export default Q5;
